!function() {
  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, t = {}, s = {}, i = e.parcelRequire5f74;
  null == i && ((i = function(e) {
    if (e in t) return t[e].exports;
    if (e in s) {
      var i = s[e];
      delete s[e];
      var o = {
        id: e,
        exports: {}
      };
      return t[e] = o, i.call(o.exports, o, o.exports), o.exports;
    }
    var r = new Error("Cannot find module '" + e + "'");
    throw r.code = "MODULE_NOT_FOUND", r;
  }).register = function(e, t) {
    s[e] = t;
  }, e.parcelRequire5f74 = i), (0, i.register)("gjV2B", function(e, t) {
    var s, i, o, r;
    s = e.exports, i = "debounce", o = function() {
      return a;
    }, Object.defineProperty(s, i, {
      get: o,
      set: r,
      enumerable: !0,
      configurable: !0
    });
    const a = (e, t) => {
      let s;
      const i = (...i) => {
        clearTimeout(s), s = setTimeout(() => {
          clearTimeout(s), e(...i);
        }, t);
      };
      return i.cancel = () => {
        clearTimeout(s), s = null;
      }, i;
    };
  });
  var o = i("gjV2B");
  customElements.get("image-swap") || customElements.define("image-swap", class extends HTMLElement {
    constructor() {
      super(), this.els = {
        buttons: this.querySelectorAll(".image-swap__group-buttons > li > label"),
        buttonURL: this.querySelectorAll(".image-swap__group-buttons > li > label[data-swap-url]"),
        containers: this.querySelectorAll(".image-swap__group-images"),
        toggles: this.querySelectorAll("input.image-swap__group-toggle"),
        defaultToggle: this.querySelector("input.image-swap__group-toggle:checked"),
        images: this.querySelector(".image-swap__group-images"),
        bodies: this.querySelector(".image-swap__group-bodies")
      }, this.state = {
        currentId: this.els.defaultToggle?.id.split("-").pop(),
        observers: new Map,
        timeouts: {
          mouse: null,
          intersection: null
        }
      }, this.mq = {
        hover: matchMedia("(hover: none)"),
        tablet: matchMedia("(min-width: 721px) and (max-width: 1024px)"),
        mobile: matchMedia("(max-width: 720px)")
      }, this.handleButtonClick = this.handleButtonClick.bind(this), this.init();
    }
    get isMobile() {
      return this.mq.tablet.matches || this.mq.mobile.matches;
    }
    animate(e, t, s = {}) {
      return e.animate(t, {
        duration: 300,
        ...s
      });
    }
    clearTimeouts() {
      Object.values(this.state.timeouts).forEach(clearTimeout);
    }
    clearAnimations(e) {
      [ ...e.children ].forEach(e => e.getAnimations().forEach(e => e.cancel()));
    }
    setStyles(e, t) {
      Object.assign(e.style, t);
    }
    setupDesktop(e = !1) {
      e && this.cleanup(), this.calculateBodyHeight(), [ ...this.els.images.children ].forEach(e => {
        const t = e.dataset.groupImages === this.state.currentId;
        this.setStyles(e, {
          zIndex: t ? "1" : "0",
          opacity: t ? "1" : "0"
        });
      });
    }
    handleButtonClick(e) {
      const t = (e.target || e.currentTarget).closest("label");
      if (!t) return;
      const s = t.getAttribute("data-swap-url");
      s && (window.location.href = s);
    }
    setupHover() {
      const e = (e, t) => {
        if (this.clearTimeouts(), !t) return;
        const s = this.querySelector(`input[type="radio"]#${e.target.getAttribute("for")}`);
        s && !s.checked && (this.state.timeouts.mouse = setTimeout(() => s.click(), 150));
      };
      this.els.buttons.forEach(t => {
        t.addEventListener("mouseenter", t => e(t, !0)), t.addEventListener("mouseleave", t => e(t, !1));
      }), this.els.buttonURL.forEach(e => e.addEventListener("click", this.handleButtonClick));
    }
    setupTablet(e = !1) {
      e && this.cleanup(), this.calculateBodyHeight(), this.els.containers.forEach(t => {
        const s = t.dataset.groupImagesForParentGroup;
        this.state.observers.has(s) && !e || this.state.observers.set(s, this.createObserver(t)), 
        t.querySelectorAll("div[data-group-images]").forEach(e => {
          this.state.observers.get(s).observe(e);
        });
      }), this.els.buttonURL.forEach(e => e.removeEventListener("click", this.handleButtonClick)), 
      [ ...this.els.images.children ].forEach(e => e.removeAttribute("style"));
    }
    calculateBodyHeight() {
      const {bodies: e} = this.els;
      this.setStyles(e, {
        overflow: "hidden",
        height: "0px"
      });
      const t = Math.max(...[ ...e.children ].map(e => {
        this.setStyles(e, {
          display: "block"
        });
        const t = e.offsetHeight;
        return this.setStyles(e, {
          display: null
        }), t;
      }));
      this.setStyles(e, {
        height: `${t}px`,
        overflow: null
      });
    }
    cleanup() {
      this.state.observers.forEach((e, t) => {
        e.disconnect(), this.state.observers.delete(t);
      }), this.clearAnimations(this.els.bodies), this.clearAnimations(this.els.images);
    }
    createObserver(e) {
      return new IntersectionObserver(e => {
        clearTimeout(this.state.timeouts.intersection);
        const t = e.find(e => e.isIntersecting);
        t && (this.state.timeouts.intersection = setTimeout(() => {
          const e = this.querySelector(`input[type="radio"]#${t.target.dataset.groupImageFor}`);
          e && !e.checked && e.click();
        }, 150));
      }, {
        root: e,
        threshold: 1,
        rootMargin: this.mq.tablet.matches ? `0px -${screen.width / 3 * 2}px 0px 0px` : "0px"
      });
    }
    switchGroup(e) {
      if (e === this.state.currentId) return;
      const t = [], s = this.els.bodies.querySelector(`[data-group-button="${this.state.currentId}"]`), i = this.isMobile ? null : this.els.images.querySelector(`div[data-group-images="${this.state.currentId}"]`);
      if (s) {
        const e = this.animate(s, {
          opacity: [ 1, 0 ]
        });
        e.onfinish = () => this.setStyles(s, {
          visibility: "hidden"
        }), t.push(e.finished);
      }
      if (i) {
        const e = this.animate(i, {
          opacity: [ 1, 0 ]
        });
        e.onfinish = () => this.setStyles(i, {
          zIndex: "-1"
        }), t.push(e.finished);
      }
      const o = () => {
        const t = this.els.bodies.querySelector(`[data-group-button="${e}"]`), s = this.isMobile ? null : this.els.images.querySelector(`div[data-group-images="${e}"]`);
        t && (this.setStyles(t, {
          visibility: "visible"
        }), this.animate(t, {
          opacity: [ 0, 1 ]
        }, {
          fill: "forwards"
        })), s && (this.setStyles(s, {
          zIndex: "1"
        }), this.animate(s, {
          opacity: [ 0, 1 ]
        }, {
          fill: "forwards"
        })), this.state.currentId = e;
      };
      t.length ? Promise.all(t).then(o) : o();
    }
    init() {
      [ ...this.els.bodies.children ].forEach(e => {
        const t = e.dataset.groupButton === this.state.currentId;
        this.setStyles(e, {
          visibility: t ? "visible" : "hidden",
          opacity: t ? "1" : "0"
        });
      }), this.isMobile || [ ...this.els.images.children ].forEach(e => {
        const t = e.dataset.groupImages === this.state.currentId;
        this.setStyles(e, {
          zIndex: t ? "1" : "-1",
          opacity: t ? "1" : "0"
        });
      }), this.mq.hover.matches || this.setupHover(), this.isMobile && this.setupTablet(), 
      this.mq.hover.addEventListener("change", e => e.matches ? null : this.setupHover());
      const e = (0, o.debounce)(() => {
        this.isMobile ? this.setupTablet(!0) : this.setupDesktop(!0);
      }, 200);
      addEventListener("resize", e), this.els.toggles.forEach(e => {
        e.addEventListener("change", e => {
          const t = e.target.id.split("-").pop();
          this.switchGroup(t);
        });
      });
    }
  });
}();